import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../config/api';
import './OrderSearch.css';

const OrderSearch = ({ placeholder = 'Search by order ID (e.g. CX-1234 or 1234)' }) => {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSearch = async (e) => {
    e.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) return;
    setError('');
    setLoading(true);
    try {
      const response = await api.get(`/orders/by-code/${encodeURIComponent(trimmed)}`);
      navigate(`/orders/${response.data.orderId}`);
    } catch (err) {
      setError(err.response?.status === 404 ? 'Order not found' : (err.response?.data?.error || 'Search failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="order-search">
      <form onSubmit={handleSearch} className="order-search-form">
        <input
          type="text"
          className="form-control order-search-input"
          placeholder={placeholder}
          value={code}
          onChange={(e) => { setCode(e.target.value); setError(''); }}
          disabled={loading}
        />
        <button type="submit" className="btn btn-primary order-search-btn" disabled={loading}>
          {loading ? 'Opening...' : 'Open Order'}
        </button>
      </form>
      {error && <div className="order-search-error">{error}</div>}
    </div>
  );
};

export default OrderSearch;
